import { InjectionToken } from '@angular/core';
import type { PmWorkspaceComponent } from '../../../layout/pm-workspace/pm-workspace.component';

/**
 * What the top bar still reads from the workspace: the active page and visible nav items, the collapse flag set by checkTopNavFit(), the global search state shared with the results popup, the popup open flags and the shared dropdown state.
 * The workspace provides itself under this token. Shrinks as the shared stores are split out.
 */
export type PmShellTopBarHost = Pick<
  PmWorkspaceComponent,
  | 'activeDropdown'
  | 'activeItem'
  | 'announcements'
  | 'checkTopNavFit'
  | 'docHubStore'
  | 'documentHubPage'
  | 'effectiveActingUserId'
  | 'effectivePracticeParentUserId'
  | 'ensureWorkspaceProfileFromTeam'
  | 'getCustomLabel'
  | 'headerAnnouncementsLoading'
  | 'headerAnnouncementsPreview'
  | 'headerAnnouncementsUnreadCount'
  | 'headerGlobalSearchActiveIndex'
  | 'headerGlobalSearchDebounceTimer'
  | 'headerGlobalSearchDebouncing'
  | 'headerGlobalSearchError'
  | 'headerGlobalSearchFlatResults'
  | 'headerGlobalSearchHasSearched'
  | 'headerGlobalSearchLoading'
  | 'headerGlobalSearchQuery'
  | 'headerGlobalSearchRequestSub'
  | 'headerGlobalSearchResults'
  | 'isAppLauncherOpen'
  | 'isMobileNavOpen'
  | 'isNotificationOpen'
  | 'isProfileMenuOpen'
  | 'isQuickAddOpen'
  | 'isSearchExpanded'
  | 'onHeaderGlobalSearchResultClick'
  | 'profile'
  | 'refreshHeaderAnnouncementsData'
  | 'stopProp'
  | 'stopPropAllowSpaceInFields'
  | 'toggleQuickAdd'
  | 'topNavCollapsed'
  | 'updateHeaderGlobalSearchModalPlacement'
  | 'visibleNavItems'
>;

export const PM_SHELL_TOP_BAR_HOST = new InjectionToken<PmShellTopBarHost>('PmShellTopBarHost');
